import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_get_manufacturing_order_lines_components_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { finished_good_id: number, warehouse_id: number }): 
  Promise<{ result: { Id?: number, Amount?: number, FinishedGoodLineId?: number, LineNumber?: number, MaterialId?: number, OrderId?: number, PackagedAmount?: number, PackagingId?: number, ParentId?: number, StatusId?: number, FinishedGoodLine?: { Amount?: number, LineNumber?: number, MaterialId?: number, PackagedAmount?: number }, Material?: { Id?: number, ControllerTypeId?: number, Description?: string, Name?: string, PackagingLookups?: { PackagingId?: number, Packaging?: { ShortName?: string } }[], InventoryByWarehouseMaterial?: { MaterialId?: number, PackagedId?: number, CurrentlyAvailablePackagedAmount?: number }[] }, Status?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.finished_good_id)) {
      missingRequiredInParams.push('\'finished_good_id\'');
    }
    if (isNil(inParams.warehouse_id)) {
      missingRequiredInParams.push('\'warehouse_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_manufacturing_order_lines_components_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { finished_good_id: number, warehouse_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Amount?: number, FinishedGoodLineId?: number, LineNumber?: number, MaterialId?: number, OrderId?: number, PackagedAmount?: number, PackagingId?: number, ParentId?: number, StatusId?: number, FinishedGoodLine?: { Amount?: number, LineNumber?: number, MaterialId?: number, PackagedAmount?: number }, Material?: { Id?: number, ControllerTypeId?: number, Description?: string, Name?: string, PackagingLookups?: { PackagingId?: number, Packaging?: { ShortName?: string } }[], InventoryByWarehouseMaterial?: { MaterialId?: number, PackagedId?: number, CurrentlyAvailablePackagedAmount?: number }[] }, Status?: { Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.finished_good_id)) {
      missingRequiredInParams.push('\'finished_good_id\'');
    }
    if (isNil(inParams.warehouse_id)) {
      missingRequiredInParams.push('\'warehouse_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_manufacturing_order_lines_components_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { finished_good_id: number, warehouse_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Amount?: number, FinishedGoodLineId?: number, LineNumber?: number, MaterialId?: number, OrderId?: number, PackagedAmount?: number, PackagingId?: number, ParentId?: number, StatusId?: number, FinishedGoodLine?: { Amount?: number, LineNumber?: number, MaterialId?: number, PackagedAmount?: number }, Material?: { Id?: number, ControllerTypeId?: number, Description?: string, Name?: string, PackagingLookups?: { PackagingId?: number, Packaging?: { ShortName?: string } }[], InventoryByWarehouseMaterial?: { MaterialId?: number, PackagedId?: number, CurrentlyAvailablePackagedAmount?: number }[] }, Status?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.finished_good_id)) {
      missingRequiredInParams.push('\'finished_good_id\'');
    }
    if (isNil(inParams.warehouse_id)) {
      missingRequiredInParams.push('\'warehouse_id\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_manufacturing_order_lines_components_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      finished_good_id: number, warehouse_id: number    }) {
        if(isNil(inParams.finished_good_id)) {
          return true; 
        }
        if(isNil(inParams.warehouse_id)) {
          return true; 
        }
      return false;
    }
}
